import { mdiChevronDown, mdiLicense } from '@mdi/js'
import {
  LicensesGroupHeadingDescription,
  LicensesGroupHeadingDropdownIcon,
  LicensesGroupHeadingLabel,
  LicensesGroupHeadingLeft,
  LicensesGroupHeadingLicenseIcon,
  LincesesGroupHeadingRight,
  LicensesGroupHeadingCount,
  LicensesGroupHeadingCountMobile,
  LicensesGroupHeadingTitle,
} from './styles'

interface LicensesGroupHeadingProps {
  title: string
  label: string
  rowCount?: string | number
  chevronRotate: boolean
}

function LicensesGroupHeading({
  title,
  label,
  rowCount,
  chevronRotate,
}: LicensesGroupHeadingProps) {
  return (
    <>
      <LincesesGroupHeadingRight>
        <div>
          <LicensesGroupHeadingLicenseIcon path={mdiLicense} />
        </div>
        <LicensesGroupHeadingDescription>
          <LicensesGroupHeadingTitle>{title}</LicensesGroupHeadingTitle>
          <LicensesGroupHeadingLabel>{label}</LicensesGroupHeadingLabel>
          <LicensesGroupHeadingCountMobile>
            {rowCount}
          </LicensesGroupHeadingCountMobile>
        </LicensesGroupHeadingDescription>
      </LincesesGroupHeadingRight>
      <LicensesGroupHeadingLeft>
        <LicensesGroupHeadingCount>{rowCount}</LicensesGroupHeadingCount>
        <div>
          <LicensesGroupHeadingDropdownIcon
            size={1}
            path={mdiChevronDown}
            rotate={chevronRotate ? 180 : 0}
          />
        </div>
      </LicensesGroupHeadingLeft>
    </>
  )
}

export default LicensesGroupHeading
